<template>
  <ax-dialog 
    ref="dialog"
    title="Import Wells" 
    icon="mdi-import" 
    tooltip="Import wells" 
    size="small"
    @submitted="onSubmit"
    @shown="onShow"
  >
    <template slot="content">
      <v-card-text>
        <v-textarea v-model="wells" :rules="rules.required" label="List of Well APIs" hint="Enter as comma-separated list or one well per line"></v-textarea>
      </v-card-text>
    </template>
    <template slot="submit_text">Import</template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
export default {
  name: "dlgImportWells",
  components: {
    AxDialog
  },
  data() {
    return {
      wells: '',
      rules: {}
    }
  },
  methods: {
    onShow() {
      this.rules = {}
      this.wells = null
    },
    onSubmit() {
      this.rules = {
        required: [
          v => !!v || 'Required',
          v => !this.isEmpty(v)
        ]
      }
      this.$nextTick(() => {
        //manually trigger Vuetify validation
        if (this.$refs.dialog.$refs.form.validate()) {
          this.$refs.dialog.show = false
          const output = this.wells.replace(/[ ,]+/g, '\n').split('\n')
          this.$emit('submitted', output)
        }
      })
    }
  }
}
</script>